import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {ContainerGoodData} from "@portbase/bezoekschip-service-typescriptmodels";
import {PortvisitUtils} from "../../portvisit-utils";

@Component({
    selector: 'app-edit-container-good',
    templateUrl: './edit-container-good.component.html',
    styleUrls: ['./edit-container-good.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditContainerGoodComponent {
  context = PortvisitUtils;

  @Input() containerGood: ContainerGoodData;
}
